import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { fetchProjectDetail } from 'collections/project';
import { getProjectTasksFromCollection, removeAsSubtask, taskCollection } from 'collections/tasks';
import { getProjectDependencyMapKey } from 'queries/common';
import { invalidateTaskQuery } from 'utils/invalidate-task-query';
import { removeAsSubtaskSagaAction, removeAsSubtaskSuccessAction } from '../actions';
function* removeAsSubtaskSaga({ payload }) {
    const { projectId, taskId, queryClient, parentTaskId, phaseId } = payload;
    const task = taskCollection.get(taskId);
    const queryTasks = getProjectTasksFromCollection(projectId);
    if (!queryTasks.length) {
        return;
    }
    try {
        const updatedTask = yield removeAsSubtask(taskId);
        taskCollection.externalDelete(taskId);
        taskCollection.push([
            updatedTask
        ], {
            source: 'mutation'
        });
        if (parentTaskId) {
            yield invalidateTaskQuery(parentTaskId);
        }
        // Detail is collection-backed — refetch+push.
        yield fetchProjectDetail(projectId);
        yield queryClient.invalidateQueries(getProjectDependencyMapKey(projectId));
        if (!phaseId) {
            return;
        }
        yield put(removeAsSubtaskSuccessAction({
            taskId,
            projectId,
            phaseId
        }));
    } catch (error) {
        message.error('There was an error processing your request.', error);
        if (task) {
            taskCollection.push([
                task
            ], {
                source: 'mutation'
            });
        }
    }
}
export const watchRemoveAsSubtaskSaga = function*() {
    yield takeLatest(removeAsSubtaskSagaAction.type, removeAsSubtaskSaga);
};
